import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { PrivateService } from '../_services/private.service';
import { officeConfiguration } from '../_models/case-configuration';
import { FormControl, ValidationErrors } from '@angular/forms';
import DOMPurify from 'dompurify';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CountryModel, customeModel, memberModel, optionStringModel, specialCustomeModel } from '../_models/country-model';
import countries from 'src/assets/json/countries-wipo.json';
import { CookieService } from 'ngx-cookie-service';
import customeOptions from 'src/assets/json/customeOptions.json';

const TOTAL_WORD_SIZE: number = 3000;

@Injectable({
  providedIn: 'root' // Just do @Injectable() if you're not on Angular v6+
})

export class UtilsService {

  AMC_LANGUAGE_COOKIE = 'amc_lang'; // WIPO language standard cookie name
  officeConfigDetailsSubject = new BehaviorSubject([]);
  countryOptions = [];
  customeOptions = [];
  DIPcustomeOptions = [];
  countryList = countries;
  currentLanguage = 'en';
  currentLanguage1 = 'en';
  currentLanguage2 = 'en';
  currentLanguage3 = 'en';
  currentLanguage4 = 'en';
  currentLanguage5 = 'en';
  currentLanguage6 = 'en';
  currentLanguage7 = 'en';
  currentLanguage8 = 'en';
  currentLanguage9 = 'en';
  currentLanguage10 = 'en';
  currentLanguage11 = 'en';
  currentLanguage12 = 'en';


  optionMeetingMinutes = ['00', 30];
  optionMeetingTime = [];

  optionsCountries: any[] = [];
  optionsCaseOutcome: any[] = [];
  optionstypeOfDispute: any[] = [];
  genderOptions: any[] = [];
  attendanceOptions: any[] = [];
  enforcementOptions: any[] = [];
  typeOfPartyOptions: any[] = [];
  countryCache: any[] = [];
  caseOutCache: any[] = [];
  DIPcaseOutCache: any[] = [];
  typeOfDisputeCache: any[] = [];
  enforcementCache: any[] = [];
  typeOfPartyCache: any[] = []; ONDA_typeOfPartyCache: any[] = [];
  genderCache: any[] = [];
  languageCache: any[] = [];
  questionsOptions: any[] = [];
  DIPtypeOfDisputeCache: any[] = [];
  optionsCopyrightCategoriesCache: any[] = [];
  optionsRelatedCategoriesCache: any[] = [];
  audienceModalityOptions: any[] = [];
  notificationModalityOptions: any[] = [];

  blocked = false;


  constructor(private router: Router, private service: PrivateService, private cookieService: CookieService,
    private activatedRoute: ActivatedRoute, private translate: TranslateService) { }

  debounce(fn, delay) {
    let timer = null;
    return function () {
      const context = this, args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(context, args);
      }, delay);
    };
  }

  loadTime() {
    for (let index = 1; index <= 23; index++) {
      let h = index >= 12 ? "PM" : "AM"
      for (const element of this.optionMeetingMinutes) {
        let digit = this.hasOneDigit(index) ? '0' + index : index;
        this.optionMeetingTime.push({ "label": digit + ":" + element + " " + h, "value": digit + ":" + element });
      }
    }
    return this.optionMeetingTime;
  }

  extractTime(input) {
    if (input) {
      let time = input?.split('T')
      let timeVal = time[1]?.split(":")
      // Format the time as HH:MM
      const formattedTime = timeVal[0] + ":" + timeVal[1];
      return formattedTime;
    } else {
      return null;
    }

  }

  loadOptions(optionsVal) {
    this.customeOptions = [];
    let options: customeModel;
    optionsVal.forEach(element => {
      options = new customeModel();
      options.label = this.translate.instant(element.label);
      options.value = element.value;
      this.customeOptions.push(options);
    });
    return this.customeOptions;
  }

  loadGenderOptions() {
    this.customeOptions = [];
    let options: customeModel;
    customeOptions.genderOptions.forEach(element => {
      options = new customeModel();
      options.label = this.translate.instant(element.label);
      options.value = element.value;
      this.customeOptions.push(options);
    });
    return this.customeOptions;
  }

  getGenderOptions() {
    const language = this.cookieService.get(this.AMC_LANGUAGE_COOKIE);
    if (this.currentLanguage1 === language && this.genderCache.length > 0) {
      return this.genderCache;
    }
    this.currentLanguage1 = language;
    this.genderCache = this.loadGenderOptions();
    return this.genderCache;
  }

  getLanguageName(languageCode) {
    this.customeOptions = [];
    let options: optionStringModel;
    let languageName = customeOptions.optionsLanguageList.find(element => element.value === languageCode.toUpperCase());
    return languageName?.label;
  }

  loadlanguageOptions() {
    this.customeOptions = [];
    let options: optionStringModel;
    customeOptions.optionsLanguageList.forEach(element => {
      options = new optionStringModel();
      options.label = this.translate.instant(element.label);
      options.value = element.value.toLowerCase();
      this.customeOptions.push(options);
    });
    return this.customeOptions;
  }

  getlanguageOptions() {
    const language = this.cookieService.get(this.AMC_LANGUAGE_COOKIE);
    if (this.currentLanguage11 === language && this.languageCache.length > 0) {
      return this.languageCache;
    }
    this.currentLanguage11 = language;
    this.languageCache = this.loadlanguageOptions();
    return this.languageCache;
  }

  loadtypeOfPartyOptions() {
    this.customeOptions = [];
    let options: customeModel;
    customeOptions.typeOfPartyOptions.forEach(element => {
      options = new customeModel();
      options.label = this.translate.instant(element.label);
      options.value = element.value;
      this.customeOptions.push(options);
    });
    return this.customeOptions;
  }

  getTypeOfPartyOptions() {
    const language = this.cookieService.get(this.AMC_LANGUAGE_COOKIE);
    if (this.currentLanguage2 === language && this.typeOfPartyCache.length > 0) {
      return this.typeOfPartyCache;
    }
    this.currentLanguage2 = language;
    this.typeOfPartyCache = this.loadtypeOfPartyOptions();
    return this.typeOfPartyCache;
  }

  ONDA_typeOfPartyOptions() {
    this.customeOptions = [];
    let options: customeModel;
    customeOptions.typeOfPartyOptions.forEach(element => {
      options = new customeModel();
      options.label = this.translate.instant(element.label);
      options.value = element.value;
      if (options.value !== 3 && options.value !== 4) this.customeOptions.push(options);
    });
    return this.customeOptions;
  }

  get_ONDA_typeOfPartyOptions() {
    const language = this.cookieService.get(this.AMC_LANGUAGE_COOKIE);
    if (this.currentLanguage10 === language && this.ONDA_typeOfPartyCache.length > 0) {
      return this.ONDA_typeOfPartyCache;
    }
    this.currentLanguage10 = language;
    this.ONDA_typeOfPartyCache = this.ONDA_typeOfPartyOptions();
    return this.ONDA_typeOfPartyCache;
  }

  loadEnforcementOptions() {
    this.customeOptions = [];
    let options: customeModel;
    customeOptions.enforcementOptions.forEach(element => {
      options = new customeModel();
      options.label = this.translate.instant(element.label);
      options.value = element.value;
      this.customeOptions.push(options);
    });
    return this.customeOptions;
  }

  getEnforcementOptions() {
    const language = this.cookieService.get(this.AMC_LANGUAGE_COOKIE);
    if (this.currentLanguage3 === language && this.enforcementCache.length > 0) {
      return this.enforcementCache;
    }
    this.currentLanguage3 = language;
    this.enforcementCache = this.loadEnforcementOptions();
    return this.enforcementCache;
  }

  loadTypeOfDisputeOptions() {
    this.customeOptions = [];
    let options: customeModel;
    customeOptions.typeOfDisputeOptions.forEach(element => {
      options = new customeModel();
      options.label = this.translate.instant(element.label);
      options.value = element.value;
      this.customeOptions.push(options);
    });
    return this.customeOptions;
  }

  load_DIP_typeOfDisputeOptions() {
    this.customeOptions = [];
    let options: customeModel;
    customeOptions.DIP_typeOfDisputeOptions.forEach(element => {
      options = new customeModel();
      options.label = this.translate.instant(element.label);
      options.value = element.value;
      this.customeOptions.push(options);
    });
    return this.customeOptions;
  }

  loadOptionsCopyrightCategories() {
    this.customeOptions = [];
    let options: specialCustomeModel;
    customeOptions.optionsCopyrightCategories.forEach(element => {
      options = new specialCustomeModel();
      options.label = this.translate.instant(element.label);
      options.value = element.value;
      options.isBold = element.isBold;
      this.customeOptions.push(options);
    });
    return this.customeOptions;
  }

  getOptionsCopyrightCategories() {
    const language = this.cookieService.get(this.AMC_LANGUAGE_COOKIE);
    if (this.currentLanguage8 === language && this.optionsCopyrightCategoriesCache.length > 0) {
      return this.optionsCopyrightCategoriesCache;
    }
    this.currentLanguage8 = language;
    this.optionsCopyrightCategoriesCache = this.loadOptionsCopyrightCategories();
    return this.optionsCopyrightCategoriesCache;
  }

  loadOptionsRelatedCategories() {
    this.customeOptions = [];
    let options: customeModel;
    customeOptions.optionsRelatedCategories.forEach(element => {
      options = new customeModel();
      options.label = this.translate.instant(element.label);
      options.value = element.value;
      this.customeOptions.push(options);
    });
    return this.customeOptions;
  }

  getOptionsRelatedCategories() {
    const language = this.cookieService.get(this.AMC_LANGUAGE_COOKIE);
    if (this.currentLanguage9 === language && this.optionsRelatedCategoriesCache.length > 0) {
      return this.optionsRelatedCategoriesCache;
    }
    this.currentLanguage9 = language;
    this.optionsRelatedCategoriesCache = this.loadOptionsRelatedCategories();
    return this.optionsRelatedCategoriesCache;
  }

  getTypeOfDisputeOptions() {
    const language = this.cookieService.get(this.AMC_LANGUAGE_COOKIE);
    if (this.currentLanguage4 === language && this.typeOfDisputeCache.length > 0) {
      return this.typeOfDisputeCache;
    }
    this.currentLanguage4 = language;
    this.typeOfDisputeCache = this.loadTypeOfDisputeOptions();
    return this.typeOfDisputeCache;
  }

  get_DIP_TypeOfDisputeOptions() {
    const language = this.cookieService.get(this.AMC_LANGUAGE_COOKIE);
    if (this.currentLanguage7 === language && this.DIPtypeOfDisputeCache.length > 0) {
      return this.DIPtypeOfDisputeCache;
    }
    this.currentLanguage7 = language;
    this.DIPtypeOfDisputeCache = this.load_DIP_typeOfDisputeOptions();
    return this.DIPtypeOfDisputeCache;
  }

  loadCaseOutOptions() {
    this.customeOptions = [];
    let options: customeModel;
    customeOptions.caseOutcomeOptions.forEach(element => {
      options = new customeModel();
      options.label = this.translate.instant(element.label);
      options.value = element.value;
      this.customeOptions.push(options);
    });
    return this.customeOptions;
  }

  DIPloadCaseOutOptions() {
    this.DIPcustomeOptions = [];
    let options: customeModel;
    customeOptions.DIPcaseOutcomeOptions.forEach(element => {
      options = new customeModel();
      options.label = this.translate.instant(element.label);
      options.value = element.value;
      this.DIPcustomeOptions.push(options);
    });
    return this.DIPcustomeOptions;
  }

    queOptions() {
    this.questionsOptions = [];
    let options: memberModel;
    customeOptions.questions.forEach(element => {
      options = new memberModel();
      options.label = this.translate.instant(element.label);
      options.value = element.value;
      this.questionsOptions.push(options);
    });
    return this.questionsOptions;
  }

    audienceModalityOptionsList() {
    this.audienceModalityOptions = [];
    let options: customeModel;
    customeOptions.audienceModalityOptions.forEach(element => {
      options = new customeModel();
      options.label = this.translate.instant(element.label);
      options.value = element.value;
      this.audienceModalityOptions.push(options);
    });
    return this.audienceModalityOptions;
  }

  notificationModalityOptionsList() {
    this.notificationModalityOptions = [];
    let options: customeModel;
    customeOptions.notificationModalityOptions.forEach(element => {
      options = new customeModel();
      options.label = this.translate.instant(element.label);
      options.value = element.value;
      this.notificationModalityOptions.push(options);
    });
    return this.notificationModalityOptions;
  }

  getCaseOutOptions() {
    const language = this.cookieService.get(this.AMC_LANGUAGE_COOKIE);
    if (this.currentLanguage5 === language && this.caseOutCache.length > 0) {
      return this.caseOutCache;
    }
    this.currentLanguage5 = language;
    this.caseOutCache = this.loadCaseOutOptions();
    return this.caseOutCache;
  }


  DIPgetCaseOutOptions() {
    const language = this.cookieService.get(this.AMC_LANGUAGE_COOKIE);
    if (this.currentLanguage12 === language && this.DIPcaseOutCache.length > 0) {
      return this.DIPcaseOutCache;
    }

    this.currentLanguage12 = language;
    this.DIPcaseOutCache = this.DIPloadCaseOutOptions();
    return this.DIPcaseOutCache;
  }





  getTitleKeyfromCountry() {
    let language = this.cookieService.get(this.AMC_LANGUAGE_COOKIE);
    const languageMap = {
      es: 'TITLE_ES',
      fr: 'TITLE_FR',
      ar: 'TITLE_AR',
      ru: 'TITLE_RU',
      zh: 'TITLE_ZH',
      default: 'TITLE_EN'
    };
    return languageMap[language] || languageMap.default;
  }

  async getCountryByCode(countryCode) {
    if (countryCode) {
      const titleKey = this.getTitleKeyfromCountry()
      let countryDetails = this.countryList.find(element => element.CODE === countryCode);
      if (countryDetails) {
        return countryDetails[titleKey]
      }
    } else
      return '';
  }

  getCountryOptions() {
    const language = this.cookieService.get(this.AMC_LANGUAGE_COOKIE);
    if (this.currentLanguage6 === language && this.countryCache.length > 0) {
      return this.countryCache;
    }
    this.currentLanguage6 = language;
    this.countryCache = this.loadCountryOption();
    return this.countryCache;
  }

  loadCountryOption() {
    this.currentLanguage = this.cookieService.get(this.AMC_LANGUAGE_COOKIE);
    this.countryOptions = [];
    const titleKey = this.getTitleKeyfromCountry()
    this.countryList.forEach(element => {
      const countryLabel = element[titleKey];
      const country = new CountryModel();
      country.label = countryLabel;
      country.value = element.CODE;
      this.countryOptions.push(country);
    });
    return this.countryOptions.sort((a, b) => a.label.localeCompare(b.label));
  }



  isBlank(value: any): boolean {
    if (value !== null && value !== undefined) {
      if ((typeof value === 'string' && value.trim().length == 0) ||
        (value instanceof Array && value.length == 0))
        return true;
      else
        return false;
    }
    return true;
  }


  customWordCountValidator(control: FormControl): ValidationErrors | null {
    const words = control?.value?.split(/\s+/).length;
    if (words > TOTAL_WORD_SIZE) {
      return { wordCount: true }; // Custom error key
    }
    return null;
  }

  officeConfigDetails(officeName) {
    return new Promise<any>((resolve) => {
      this.service.getOfficeConfiguration(officeName).subscribe((response: officeConfiguration[]) => {
        if (response) {
          resolve(response)
        }
      });
    });
  }

  async verifyOfficeConfiguration(office): Promise<any[]> {
    try {
      const response = await this.service.getOfficeConfiguration(office).toPromise();
      if (!response) {
        this.router.navigate(['page-not-found']);
      }
      return response;
    } catch (error) {
      // handle error
      console.error(error);
    }
  }



  createInternalCase(currentLang, officeName) {
    this.router.navigate(['/' + currentLang + '/office/private/' + officeName.toLowerCase() + '/register-case']);
  }

  async getFilter(filterValue: any, casesDetails) {
    if (filterValue) {
      const filterValueLower = filterValue.toLowerCase();
      return casesDetails.filter((el: any) =>
        el?.nameClaimant?.toLowerCase().includes(filterValueLower) ||
        el?.emailClaimant?.toLowerCase().includes(filterValueLower) ||
        el?.telephoneClaimant?.toLowerCase().includes(filterValueLower) ||
        el?.nameRespondent?.toLowerCase().includes(filterValueLower) ||
        el?.emailRespondent?.toLowerCase().includes(filterValueLower) ||
        el?.telephoneRespondent?.toLowerCase().includes(filterValueLower) ||
        el?.nameRespondentRepBy?.toLowerCase().includes(filterValueLower) ||
        el?.notes?.toLowerCase().includes(filterValueLower));
    }
  }

  countChars(textString) {
    return textString?.length > 255 ? true : false;
  }

  validateEmail(email: FormControl): ValidationErrors | null {
    let emailValue = email.value;
    if (emailValue) {
      // Validate each email address using a regex
      const EMAIL_REGEXP = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      // Check if any email address is invalid
      if (!EMAIL_REGEXP.test(emailValue)) {
        return { email: true };
      }
      return null;
    }
  }

  redirctURLperlanguage(selectedLanguage, paramsLang) {
    // this.officeDetailsSubject.next(officeDetails);
    if (selectedLanguage) {
      const selectLang = Array.isArray(selectedLanguage) ? selectedLanguage[0].toLowerCase() : selectedLanguage.toLowerCase();
      if (selectLang === paramsLang) {
        return true;
      } else if (!selectedLanguage.includes(paramsLang.toUpperCase())) {
        this.replaceLanguageUrl(selectLang, paramsLang);
      }
    }
  }


  replaceLanguageUrl(selectedLanguage, paramLanguage) {
    let newURL = this.router.url.replace(paramLanguage, selectedLanguage);
    const encodedInput = DOMPurify.sanitize(this.encodeHTML(environment.hostName + newURL));
    window.location.href = encodedInput;
  }

  encodeHTML(s) {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  }


  reportDateFormat(isoDate) {
    if (isoDate) {
      let date1 = new Date(isoDate);
      let getMonth = date1.getMonth() + 1;
      let month = this.hasOneDigit(getMonth) ? '0' + getMonth : getMonth;
      let getDate = date1.getDate();
      let displayDate = this.hasOneDigit(getDate) ? '0' + getDate : getDate;
      return displayDate + '/' + month + '/' + date1.getFullYear();
    } else return null;
  }

  converDateFormat(dateString) {
    if (!dateString) { return null; }
    const parts = dateString.split('/');
    if (parts.length !== 3) { return null; }

    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1; // Months are 0-indexed in JavaScript Date
    const year = parseInt(parts[2], 10);

    if (isNaN(day) || isNaN(month) || isNaN(year)) { return null; }
    const date = new Date(year, month, day);

    if (date.getDate() !== day || date.getMonth() !== month || date.getFullYear() !== year) { return null; }
    return date;
  }


  convertFormat(isoDate) {
    if (isoDate) {
      let date1 = new Date(isoDate);
      let firstDate = date1.getDate();
      let getMonth = date1.getMonth() + 1;
      let month = this.hasOneDigit(getMonth) ? '0' + getMonth : getMonth;
      let dateVal = this.hasOneDigit(firstDate) ? '0' + firstDate : firstDate;
      return dateVal + '-' + month + '-' + date1.getFullYear();
    } else
      return '';
  }

  setDateFormat(value: any) {
    if (value === null) {
      return null;
    }
    const rt = new Date(value);
    return rt;
  }


  hasOneDigit(val) {
    return String(Math.abs(val)).charAt(0) == val;
  }

  // hasTwoDigit(val) {
  //   const absValStr = String(Math.abs(val));
  //   return absValStr.length === 2;
  // }


  loadOptionsList() {
    this.optionsCountries = this.loadCountryOption();
    this.optionsCaseOutcome = this.loadOptions(customeOptions.caseOutcomeOptions);
    this.optionstypeOfDispute = this.loadOptions(customeOptions.typeOfDisputeOptions);
    this.attendanceOptions = this.loadOptions(customeOptions.attendanceOptions);
    this.enforcementOptions = this.loadOptions(customeOptions.enforcementOptions);
    this.typeOfPartyOptions = this.loadOptions(customeOptions.typeOfPartyOptions);
    this.genderOptions = this.loadOptions(customeOptions.genderOptions);
  }

  async getOfficeDetails(officeName) {
    let officeDetails = await this.service.getOfficeConfiguration(officeName).toPromise();
    return officeDetails;
  }

  getTimeNextMeeting(time) {
    let newTime = time.split(":")[0]
    let timeOfNextMeetingVal = (newTime > 12) ? time + ' PM' : time + ' AM';
    return timeOfNextMeetingVal;
  }

  loadCasesStatusForReports(officeName, status) {
    return new Promise<any>((resolve) => {
      this.service.getAllCasesDetailsWithStatus(officeName, status).subscribe((response: officeConfiguration[]) => {
        if (response) { resolve(response); }
      });
    });
  }

  loadCasesForReportsCSV(officeName) {
    return new Promise<any>((resolve) => {
      this.service.getAllCasesForReports(officeName).subscribe((response: officeConfiguration[]) => {
        if (response) { resolve(response); }
      });
    });
  }

  loadPreCasesForReportsCSV(officeName) {
    return new Promise<any>((resolve) => {
      this.service.getAllPreCasesForReports(officeName).subscribe((response: officeConfiguration[]) => {
        if (response) { resolve(response); }
      });
    });
  }

  async getSortData(data) {
    this.blocked = true;
    const sortedData: any = await new Promise((resolve) => {
      data.sort((a, b) => {
        let dateA: any = new Date(b.meetingDateIso);
        let dateB: any = new Date(a.meetingDateIso);
        return dateA - dateB;
      });
      resolve(data); // Resolve with sorted data
    });
    return sortedData;
  }

  // Sort the data by dateReceived
  async sortCasesByDate(cases: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      try {
        if (!cases || cases.length === 0) {
          resolve([]); // Resolve with empty array if input is empty or null
          return;
        }

        const sortedCases = [...cases].sort((a, b) => { // Create a copy to avoid mutation
          const dateA = new Date(a.dateReceived);
          const dateB = new Date(b.dateReceived);

          if (isNaN(dateA.getTime()) || isNaN(dateB.getTime())) {
            console.error("Invalid date found:", a.dateReceived, b.dateReceived);
            // Handle invalid dates. Example: put them at the end
            return isNaN(dateA.getTime()) ? 1 : (isNaN(dateB.getTime()) ? -1 : 0); //Improved handling of both dates being invalid
          }

          return dateA.getTime() - dateB.getTime();
        });

        resolve(sortedCases);
      } catch (error) {
        console.error("Error sorting cases:", error);
        reject(error); // Reject the promise on error
      }
    });
  }

  getMember(isMember) {
    if (isMember === true)
      return this.translate.instant('options.question.yes')
    else if (isMember === false)
      return this.translate.instant('options.question.no');
    else
      return '';
  }

  displayformatDate(value) {
    if (value) {
      const dateTimeString = value;
      // Split the string by spaces
      const parts = dateTimeString.toString().split('-');
      // Extract the relevant parts: Month, Day, Year
      const year = parts[0];              // "2025"
      const monthAbbreviation = parts[1]; // "Jul"
      const dayOfMonth = parts[2];        // "09"

      // Create a mapping for month abbreviations to numbers
      const monthMap = {
        "Jan": "01", "Feb": "02", "Mar": "03", "Apr": "04",
        "May": "05", "Jun": "06", "Jul": "07", "Aug": "08",
        "Sep": "09", "Oct": "10", "Nov": "11", "Dec": "12"
      };
      console.log('monthAbbreviation---', monthAbbreviation);
      console.log('dayOfMonth---', dayOfMonth);
      console.log('year---', year);
      if (year !== undefined) {
        const numericMonth = monthMap[monthAbbreviation];
        // Format as YYYY-MM-DD
        const fromatData = `${dayOfMonth}/${monthAbbreviation}/${year}`;
        console.log('formattedDateYYYYMMDD---', fromatData); // Output: 13/01/2025
        return fromatData;
      }
      else {
        // console.log(key + '-----' + parts[0]); // Output: 2025-07-09
        return parts[0];
      }
    } else {
      return null;
    }
  }

  payloadFormatDate(value) {
    if (value) {
      const monthMap = {
        "Jan": "01", "Feb": "02", "Mar": "03", "Apr": "04",
        "May": "05", "Jun": "06", "Jul": "07", "Aug": "08",
        "Sep": "09", "Oct": "10", "Nov": "11", "Dec": "12"
      };
      const dateTimeString = value.toString();
      // Check if value contains '/' and split accordingly
      const delimiter = dateTimeString.includes('/') ? '/' : ' ';
      const parts = dateTimeString.split(delimiter);

      let dayOfMonth, monthAbbreviation, year;

      if (delimiter === '/') {
        // Format: dd/MMM/yyyy
        dayOfMonth = parts[0];
        monthAbbreviation = parts[1];
        year = parts[2];
        if (year !== undefined) {
          const formattedDateYYYYMMDD = `${year}-${monthAbbreviation}-${dayOfMonth}`;
          return formattedDateYYYYMMDD;
        }
      } else {
        // Format: yyyy-MMM-dd
        const monthAbbreviation = parts[1]; // "Jul"
        const dayOfMonth = parts[2];        // "09"
        const year = parts[3];              // "2025"
        if (year !== undefined) {
          const numericMonth = monthMap[monthAbbreviation];
          const formattedDateYYYYMMDD = `${year}-${numericMonth}-${dayOfMonth}`;
          return formattedDateYYYYMMDD;
        }
      }

      // console.log('dayOfMonth---', dayOfMonth);
      // console.log('monthAbbreviation---', monthAbbreviation);
      // console.log('year---', year);



      if (year !== undefined) {
        const formattedDateYYYYMMDD = `${year}-${monthAbbreviation}-${dayOfMonth}`;
        return formattedDateYYYYMMDD;
      }
      else { return parts[0]; }
    } else { return null; }
  }

  convertDate(value) {
    if (value) {
      const dateTimeString = value;
      // Split the string by spaces
      const parts = dateTimeString.toString().split(' ');
      // Extract the relevant parts: Month, Day, Year
      const monthAbbreviation = parts[1]; // "Jul"
      const dayOfMonth = parts[2];        // "09"
      const year = parts[3];              // "2025"
      // Create a mapping for month abbreviations to numbers
      const monthMap = {
        "Jan": "01", "Feb": "02", "Mar": "03", "Apr": "04",
        "May": "05", "Jun": "06", "Jul": "07", "Aug": "08",
        "Sep": "09", "Oct": "10", "Nov": "11", "Dec": "12"
      };
      if (year !== undefined) {
        const numericMonth = monthMap[monthAbbreviation];
        // Format as YYYY-MM-DD
        const formattedDateYYYYMMDD = `${year}-${numericMonth}-${dayOfMonth}`;
        // console.log(key + '-----' + formattedDateYYYYMMDD); // Output: 2025-07-09
        return formattedDateYYYYMMDD;
      }
      else {
        // console.log(key + '-----' + parts[0]); // Output: 2025-07-09
        return parts[0];
      }
    } else {
      return null;
    }
  }


  async loadMediator(officeName) {
    const getMediatorList = await this.service.getMediatorList(officeName).toPromise();
    let mediatorList = getMediatorList.map(element => ({ 
      "label": element.alias || element.username, 
      "value": element.username 
    }));
    mediatorList.push({ "label": this.translate.instant('options.caseOutcomeVal.other'), "value": 0 })
    return mediatorList;
  }


}